// 社媒推广接口
import { http } from '~/utils/request'

export const submitSocialMediaPromoteApi = (data: {
    content_type: 'VIDEO' | 'IMAGE_TEXT',
    link: string,
    publish_time : number
}) => {
   return http.post('/api/v1/auth/promotion/submit', data)
}

// 获取用户三方绑定信息
export const getUserThirdPartyBindInfoApi = () => {
    return http.get('/api/v1/auth/user/binding/info')
}